module.exports = __webpack_public_path__ + "3714c3aac457853352588cffb648f014.svg";